import { Button, Stack, Text } from '@chakra-ui/react'
import { faVideo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTime } from 'luxon'

import { pluralize } from '@/utils/helpers'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'

import type { PostDetails } from '@/components/Community/Post/types'
import type { LiveHelpRequestBase } from '@/components/Worlds/types'

function getWaitTimeMinutes(liveHelpRequest: LiveHelpRequestBase): number {
  return Math.ceil(DateTime.now().diff(liveHelpRequest.createdAt).as('minutes'))
}

export default function TutorRequestedLiveHelpBanner({
  post,
  liveHelpRequest,
  postIsFullView,
}: {
  post: PostDetails
  liveHelpRequest: LiveHelpRequestBase
  postIsFullView: boolean
}): JSX.Element {
  const { user } = post

  const waitTimeMinutes = getWaitTimeMinutes(liveHelpRequest)

  const [handleOpenZoomRoom, isLoading] = useAPIWrapper(
    async () => {
      await RPC.openLiveHelpSession({
        postId: post.id,
      })
    },
    [post.id],
    'Open Zoom Room'
  )

  return (
    <>
      <Stack
        direction={postIsFullView ? { base: 'column', md: 'row' } : 'column'}
        align={postIsFullView ? { base: 'left', md: 'center' } : 'left'}
        justify="space-between"
        width="100%"
        p="16px"
        bgColor="bg.muted"
        borderRadius="8px"
        spacing="12px"
      >
        {/* TODO: AvatarGroup  */}
        <Stack spacing={0}>
          <Text fontWeight="bold">
            Can you help {user.displayName} with this question over Zoom?
          </Text>
          <Text>
            {user.displayName} has been waiting for help for {pluralize(waitTimeMinutes, 'minute')}.
            If you can help with this question, open a Zoom room for {user.displayName}.
          </Text>
        </Stack>
        <Button
          flexShrink={0}
          onClick={handleOpenZoomRoom}
          leftIcon={<FontAwesomeIcon icon={faVideo} />}
          isLoading={isLoading}
          disabled={isLoading}
        >
          Open a Zoom Room
        </Button>
      </Stack>
    </>
  )
}
